import Api from '@/api/API';

export default {
    Contact(data) {
        return Api.post('/Contact', data);
    }
};